import { motion } from "framer-motion";
import { ChatBar } from "../../features/kquant/components/ChatBar";
import { Search } from "lucide-react";
import { DemoPrompts } from "./DemoPrompts";

export function HeroSection({
  query,
  setQuery,
  onAnalyze,
}: {
  query: string;
  setQuery: (v: string) => void;
  onAnalyze: (text: string) => void;
}) {
  return (
    <section className="pt-8 pb-10 text-center">
      <motion.h1
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="text-[28px] font-semibold tracking-tight text-slate-900"
      >
        Your Personal Financial Advisor
      </motion.h1>

      <div className="mt-5 flex justify-center">
        <div className="relative w-[620px]">
          <ChatBar
            Icon={Search}
            value={query}
            onChange={setQuery}
            onSend={onAnalyze}
          />
        </div>
      </div>

      <DemoPrompts onSelectPrompt={setQuery} />
    </section>
  );
}
